import './ErrorComponentModel.scss';
import { Modal, Button } from 'react-bootstrap';
import { ComponentModelPopup } from '../../../../interfaces/modal.interface';

type TParams = Readonly<{ modal: ComponentModelPopup }>;

function ErrorComponentModel({ modal }: TParams) {
    const handleOkClick = () => {
        if (modal.HandleOk) {
            modal.HandleOk();
        } else {
            modal.HandleClose();
        }
    };

    return (
        <Modal
            className="error-modal-main-box"
            show={modal.Show}
            onHide={modal.HandleClose}
            backdrop="static"
            // size='lg'
            centered
            keyboard={false}>
            <Modal.Header  className="py-2 px-3">
                <Modal.Title className="w-100">{modal.Title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className=" text-center">
                {modal.Component}
            </Modal.Body>
            <Modal.Footer className="justify-content-center py-2 px-3">
                <Button onClick={handleOkClick} className="ok-button py-1 px-5">
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ErrorComponentModel;
